export default __webpack_public_path__ + "static/media/sepa-logo.5e547c04.png";